<div class="search-wrapper">
  <div class="bar">
    <div class="icon">
      <img src="assets/search-purple.svg" />
    </div>
    <input
      placeholder="Search..."
      [(ngModel)]="searchParameter"
      (input)="onSearchInput($event)"
    />
  </div>
</div>
